import state from './payer_groups/state'
import mutations from './payer_groups/mutations'
import actions from './payer_groups/actions'

export default {
  namespaced: true,
  modules: {
    payerGroups: {
      namespaced: true,
      state,
      mutations,
      actions
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/clients/store/index.js